module.exports = __webpack_public_path__ + "static/media/group-primary.f204801a.svg";